import { Discount } from "@medusajs/medusa"
import { PricedProduct, PricedVariant } from "@medusajs/medusa/dist/types/pricing"
import { useMemo } from "react"

import { getProductPrice, CalculatedProductPrice } from "@lib/util/get-product-price"
import { RegionInfo } from "types/global"

export const useGetCalculatedPrices = (
  product: PricedProduct | null,
  variant?: PricedVariant | null,
  region?: RegionInfo,
  discounts?: Discount[]
): CalculatedProductPrice | null => {
  return useMemo(() => {
    if (!product || !variant || !region) return null

    return getProductPrice({
      product: product,
      variantId: variant?.id,
      region: region,
      discounts: discounts,
    })
  }, [discounts, product, region, variant?.id])
}
